<template>
  <div>
      <base-exit-layout :showBottom="false">
      <el-container>
      <el-header> <h3>{{name}}</h3></el-header>
      <el-main>{{content}}</el-main>
      </el-container>
      </base-exit-layout>
  </div>
</template>

<script>
    import BaseExitLayout from "../../../common/BaseExitLayout";
  export default {
    name: "lesson-template-preview",
    components: {BaseExitLayout},
    data () {
      return {
          name: '',
          content: ''
      }
    },
    mounted(){

    //  this.serverUrl: '', // 服务器统一请求接口路径
    },
    created() {
      let id = this.$route.params.id;
      this.init(id)
    },
    methods: {
      init (id) {
          this.$http({
              url: this.$http.adornUrl(`/business/studenthomework/info/${id}`),
              method: 'get',
              params: this.$http.adornParams()
          }).then(({data}) => {

              if (data && data.code === 0) {
                  this.name = data.data.title

                  var contentHtml = data.data.content
                  if (contentHtml.indexOf('<p>') === 0) {
                      contentHtml = contentHtml.substring(3, contentHtml.length - 3);
                      this.content = contentHtml
                  } else {
                      this.content = contentHtml
                  }

              }
          })
      }
    }
  }
</script>
<style>

</style>
